export const openLink = (url: string) => {
  if (import.meta.env.VITE_GAME_ISDESKTOP === 'true') {
    // nw.Shell.openExternal(url as string);
    gemshell?.os.openURL(url);
  } else {
    window.open(url, '_blank');
  }
};